import { render, staticRenderFns } from "./mallOption.vue?vue&type=template&id=26c273fd&scoped=true"
import script from "./mallOption.vue?vue&type=script&lang=js"
export * from "./mallOption.vue?vue&type=script&lang=js"
import style0 from "./mallOption.vue?vue&type=style&index=0&id=26c273fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c273fd",
  null
  
)

export default component.exports